var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E7ECF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3975 45.8914C49.7597 45.1322 50.8403 45.1322 51.2025 45.8914L53.0904 49.8478C53.2362 50.1533 53.5266 50.3643 53.8622 50.4085L58.2084 50.9814C59.0423 51.0914 59.3762 52.119 58.7662 52.6981L55.5868 55.7162C55.3413 55.9493 55.2304 56.2907 55.292 56.6236L56.0902 60.934C56.2433 61.7611 55.3691 62.3962 54.6299 61.995L50.777 59.9039C50.4795 59.7424 50.1205 59.7424 49.823 59.9039L45.9701 61.995C45.2309 62.3962 44.3567 61.7611 44.5098 60.934L45.308 56.6236C45.3696 56.2907 45.2587 55.9493 45.0132 55.7162L41.8338 52.6981C41.2238 52.119 41.5577 51.0914 42.3916 50.9814L46.7377 50.4085C47.0733 50.3643 47.3638 50.1533 47.5096 49.8478L49.3975 45.8914Z",
    stroke: "#6921C4",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1975 45.8914C69.5597 45.1322 70.6403 45.1322 71.0025 45.8914L72.3144 48.6406C72.4601 48.9461 72.7506 49.1571 73.0862 49.2014L76.1063 49.5995C76.9402 49.7094 77.2741 50.7371 76.6641 51.3162L74.4548 53.4134C74.2093 53.6464 74.0983 53.9879 74.1599 54.3207L74.7146 57.316C74.8677 58.1431 73.9935 58.7782 73.2543 58.377L70.577 56.9239C70.2795 56.7624 69.9205 56.7624 69.623 56.9239L66.9457 58.377C66.2064 58.7782 65.3322 58.1431 65.4854 57.316L66.04 54.3207C66.1016 53.9879 65.9907 53.6464 65.7452 53.4134L63.5359 51.3162C62.9259 50.7371 63.2598 49.7094 64.0937 49.5995L67.1138 49.2014C67.4494 49.1571 67.7398 48.9461 67.8856 48.6406L69.1975 45.8914Z",
    stroke: "#6921C4",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5975 45.8914C29.9597 45.1322 31.0403 45.1322 31.4025 45.8914L32.7144 48.6406C32.8602 48.9461 33.1506 49.1571 33.4862 49.2014L36.5063 49.5995C37.3402 49.7094 37.6741 50.7371 37.0641 51.3162L34.8548 53.4134C34.6093 53.6464 34.4983 53.9879 34.56 54.3207L35.1146 57.316C35.2678 58.1431 34.3936 58.7782 33.6543 58.377L30.977 56.9239C30.6795 56.7624 30.3205 56.7624 30.023 56.9239L27.3457 58.377C26.6064 58.7782 25.7322 58.1431 25.8854 57.316L26.44 54.3207C26.5017 53.9879 26.3907 53.6464 26.1452 53.4134L23.9359 51.3162C23.3259 50.7371 23.6598 49.7094 24.4937 49.5995L27.5138 49.2014C27.8494 49.1571 28.1398 48.9461 28.2856 48.6406L29.5975 45.8914Z",
    stroke: "#6921C4",
    strokeWidth: 2.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 38.5L38 34",
    stroke: "#6921C4",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0701 38.6996L50.278 29.9978",
    stroke: "#6921C4",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 38.5L62 34",
    stroke: "#6921C4",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewCampaign);
export default __webpack_public_path__ + "static/media/ReviewCampaign.d6d41d0b.svg";
export { ForwardRef as ReactComponent };